import { render, staticRenderFns } from "./TextOverflow.vue?vue&type=template&id=0625b002&scoped=true"
import script from "./TextOverflow.vue?vue&type=script&lang=js"
export * from "./TextOverflow.vue?vue&type=script&lang=js"
import style0 from "./TextOverflow.vue?vue&type=style&index=0&id=0625b002&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0625b002",
  null
  
)

export default component.exports